import { ApolloClient } from 'apollo-client';
import { History } from 'history';
import { createAction } from 'typesafe-actions';

export const initApp = createAction(
  'APP/INIT',
  (resolve) => (payload: { history: History; apollo_client: ApolloClient<any> }) => resolve(payload)
);
